import MedicalRecordDelete from './medical-record-delete';

export default MedicalRecordDelete;
